<template>
  <el-dialog
    title="编辑"
    v-model="isEdit"
    width="40%"
    center
    :close-on-click-modal="false"
    @closed="dialogClosedHandle"
  >
    <div class="page_warp scroll-view">
      <div class="input_row">
        <div class="input_lable">角色名：</div>
        <div class="input_box">
          <el-input v-model="dataItem.roleName" placeholder="请输入"></el-input>
        </div>
      </div>

      <div class="input_row">
        <div class="input_lable">备注：</div>
        <div class="input_box">
          <el-input
            v-model="dataItem.roleRemark"
            placeholder="请输入"
          ></el-input>
        </div>
      </div>

      <div class="input_tree_warp">
        <div class="manage">
          <div class="input_lable">PC权限：</div>
          <div class="tree scroll-view">
            <el-tree
              :data="pcData"
              show-checkbox
              :default-expand-all="false"
              :default-expanded-keys="pcIdArr"
              node-key="id"
              ref="pcTreeRef"
              highlight-current
              :props="defaultProps"
              :default-checked-keys="dataItem.pcIdList"
              :expand-on-click-node="false"
            >
            </el-tree>
          </div>
        </div>
        <div class="manage">
          <div class="input_lable">App权限：</div>
          <div class="tree scroll-view">
            <el-tree
              :data="AppData"
              show-checkbox
              :default-expand-all="false"
              :default-expanded-keys="appIDArr"
              node-key="id"
              ref="appTreeRef"
              highlight-current
              :default-checked-keys="dataItem.appIdList"
              :props="defaultProps"
              :expand-on-click-node="false"
            >
            </el-tree>
          </div>
        </div>
      </div>

      <div class="footer_btn_warp">
        <div class="cancle_btn" @click="closeModal()">取消</div>
        <div class="confirm_btn" @click="submit()">确定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script >
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  nextTick,
} from "vue";
import { imgFileToBase64, isChinese } from "@/libs/tools";
import { useStore } from "vuex";
import { apiObj } from "@/config/api";
export default defineComponent({
  name: "Edit",

  emits: ["getData"],
  setup(props, context) {
    const store = useStore();
    const { proxy } = getCurrentInstance();

    const getData = () => {
      context.emit("getData");
    };
    onMounted(() => {});
    const data = reactive({
      isEdit: false,
      pcData: [],
      pcIdArr: [],
      AppData: [],
      appIDArr: [],
      defaultProps: {
        children: "children",
        label: "text",
      },

      dataItem: {
        roleId: "",
        roleCode: "",
        roleName: "",
        roleRemark: "",
        menuIdList: [],
        pcIdList: [],
        appIdList: [],
      },
    });
    //重置数据
    const init = async (id) => {
      data.isEdit = true;
      data.pcData = [];
      data.pcIdArr = [];
      data.AppData = [];
      data.appIDArr = [];
      data.dataItem.roleId = id;
      data.dataItem.roleCode = "";
      data.dataItem.roleName = "";
      data.dataItem.roleRemark = "";
      data.dataItem.menuIdList = [];
      data.dataItem.pcIdList = [];
      data.dataItem.appIdList = [];
      let params = {
        roleId: id,
      };
      const r = await proxy.$http.get(apiObj.roleDetail, params);
      if (r) {
        data.dataItem.roleCode = r.roleCode;
        data.dataItem.roleName = r.roleName;
        data.dataItem.roleRemark = r.roleRemark;
        getPCRoleMeau();
        getAppRoleMeau();
      }
    };
    // 获取pc菜单权限
    const getPCRoleMeau = async () => {
      let params = {
        roleId: data.dataItem.roleId,
        type: "PC",
        disabled: 0,
      };
      const r = await proxy.$http.get(apiObj.menuTree, params);
      if (r) {
        console.log(r.tree);
        let resaultData = [];
        if (r.tree == null) {
          return;
        }
        resaultData.push(r.tree);
        data.pcData = resaultData;
        let newPcIdArr = [];
        data.pcData.forEach((item) => {
          newPcIdArr.push(item.id);
        });
        data.pcIdArr = newPcIdArr;
        data.dataItem.pcIdList = r.userMenuIds;
      }
    };
    // 获取pc菜单权限
    const getAppRoleMeau = async () => {
      let params = {
        roleId: data.dataItem.roleId,
        type: "APP",
        disabled: 0,
      };
      const r = await proxy.$http.get(apiObj.menuTree, params);
      if (r) {
        console.log(r.tree);
        let resaultData = [];
        if (r.tree == null) {
          return;
        }
        resaultData.push(r.tree);
        data.AppData = resaultData;
        let appIDArr = [];
        data.AppData.forEach((item) => {
          appIDArr.push(item.id);
        });
        data.appIDArr = appIDArr;
        data.dataItem.appIdList = r.userMenuIds;
      }
    };
    const dialogClosedHandle = () => {
      data.isEdit = false;
    };
    const closeModal = () => {
      data.isEdit = false;
    };
    const submit = async () => {
      let list = [];
      let halfList = [];
      if (halfList.length > 0) {
        halfList = [];
      }
      if (list.length > 0) {
        list = [];
      }

      halfList = proxy.$refs.pcTreeRef
        .getHalfCheckedKeys()
        .concat(proxy.$refs.appTreeRef.getHalfCheckedKeys());
      halfList = uniqueArr(halfList);
      list = proxy.$refs.pcTreeRef
        .getCheckedKeys()
        .concat(proxy.$refs.appTreeRef.getCheckedKeys());
      list = uniqueArr(list);
      let dataItem = data.dataItem;
      dataItem.menuIdList = list.concat(halfList);

      console.log(dataItem);
      if (dataItem.roleName == "") {
        proxy.$message.error("请填写角色名");
        return;
      }
      if (dataItem.roleRemark == "") {
        proxy.$message.error("请填写备注");
        return;
      }
      if (dataItem.menuIdList.length <= 0) {
        proxy.$message.error("请选择权限");
        return;
      }
      let params = {
        roleId: data.dataItem.roleId,
        roleName: data.dataItem.roleName,
        roleCode: data.dataItem.roleCode,
        menuIdList: data.dataItem.menuIdList,
        roleRemark: data.dataItem.roleRemark,
        // roleOrg: store.state.userInfo.orgId,
      };
      const r = await proxy.$http.postFormData(apiObj.roleUpdate, params);
      if (r.code == 0 || r.respCode == "0000") {
        proxy.$message.success(r.msg || r.respMsg);
        getData();
        data.isEdit = false;
      } else {
        proxy.$message.error(r.msg || r.respMsg);
      }

      // data.isEdit = false;
      //
    };
    //数组去重
    const uniqueArr = (array = []) => {
      var n = []; //一个新的临时数组
      //遍历当前数组
      for (var i = 0; i < array.length; i++) {
        //如果当前数组的第i已经保存进了临时数组，那么跳过，
        //否则把当前项push到临时数组里面
        if (n.indexOf(array[i]) == -1) n.push(array[i]);
      }
      return n;
    };
    return {
      ...toRefs(data),
      init,
      closeModal,
      getData,
      getPCRoleMeau,
      getAppRoleMeau,
      dialogClosedHandle,
      submit,
      uniqueArr,
    };
  },
});
</script>
<style scoped>
.page_warp {
  width: 100%;
  max-height: 600px;
}
.input_row {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
}
.input_lable {
  width: 80px;
  text-align: right;
}
.input_box {
  width: 50%;
}
.input_tree_warp {
  width: calc(100% - 30px);
  height: 300px;
  margin-left: 30px;

  box-sizing: border-box;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.manage {
  width: 48%;
  height: 100%;

  display: flex;
}
.tree {
  width: calc(100% - 80px);
  height: 100%;
  overflow: auto;
}
.footer_btn_warp {
  width: 100%;
  height: 70px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cancle_btn {
  width: 116px;
  height: 38px;
  background: #e36a19;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 38px;
  cursor: pointer;
  margin-right: 90px;
}
.confirm_btn {
  width: 116px;
  height: 38px;
  background: #293787;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 38px;
  cursor: pointer;
}
</style>
